import confetti from "canvas-confetti";
import { useReducedMotion } from "motion/react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";

import { shouldCelebrateOnboarding } from "./celebration-state";
import { createOnboardingConfettiPlan } from "./confetti-plan";

export function OnboardingCelebration() {
  const location = useLocation();
  const navigate = useNavigate();
  const reduceMotion = Boolean(useReducedMotion());
  const shouldCelebrate = shouldCelebrateOnboarding(location.state);
  const [celebrationRequested] = useState(shouldCelebrate);

  useEffect(() => {
    if (!shouldCelebrate) return;

    navigate(
      {
        hash: location.hash,
        pathname: location.pathname,
        search: location.search,
      },
      { replace: true, state: null },
    );
  }, [
    location.hash,
    location.pathname,
    location.search,
    navigate,
    shouldCelebrate,
  ]);

  useEffect(() => {
    const plan = createOnboardingConfettiPlan(reduceMotion);
    if (!celebrationRequested || plan.length === 0) return;

    const fire = confetti.create(undefined, {
      disableForReducedMotion: true,
      resize: true,
      useWorker: true,
    });
    const timers = plan.map(({ delayMs, options }) =>
      window.setTimeout(() => {
        void fire({ ...options, zIndex: 100 });
      }, delayMs),
    );

    return () => {
      timers.forEach((timer) => window.clearTimeout(timer));
      fire.reset();
    };
  }, [celebrationRequested, reduceMotion]);

  return null;
}
